import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import BotonCancelarSAT from './BotonCancelarSAT';

const BotonesAccion = ({ isActive, handleOpenModal, datosSellos, emisor, refreshFactura }) => {
    return (
        <Row className="mt-4">
            <Col className="d-flex justify-content-end gap-2">
                <BotonCancelarSAT 
                    isActive={isActive} 
                    datosSellos={datosSellos}
                    emisor={emisor}
                    refreshFactura={refreshFactura}
                />
                <Button
                    variant="warning"
                    onClick={() => handleOpenModal('cancelar')}
                    className="px-4"
                    disabled={!isActive}
                >
                    <i className="fas fa-ban me-2"></i>
                    {isActive ? 'Cancelar Factura' : 'Ya Cancelada'}
                </Button>
                <Button
                    variant="danger"
                    onClick={() => handleOpenModal('eliminar')}
                    className="px-4"
                >
                    <i className="fas fa-trash me-2"></i>
                    Eliminar Factura
                </Button>
            </Col>
        </Row>
    );
};

BotonesAccion.propTypes = {
    isActive: PropTypes.bool,
    handleOpenModal: PropTypes.func,
    datosSellos: PropTypes.object.isRequired,
    emisor: PropTypes.object.isRequired,
    refreshFactura: PropTypes.func
};

export default BotonesAccion;